// 연락처 — 한국 전화번호 자동 하이픈 정규화 (blur 시 호출)
// 어드민 Admin/front-end/src/utils/inputFormat.ts 의 formatPhoneKR 과 동일 정책.
// 길이 기반 분기이며, 인식 불가한 형식(국제번호·내선·안심번호 등)은 원본을 유지해 손실을 막는다.

/**
 * 한국 전화번호 자동 하이픈 보정
 * @param {string|null|undefined} raw 사용자가 입력한 원본 문자열
 * @returns {string} 보정된 문자열 (인식 불가 시 원본 그대로)
 */
export function formatPhoneKR(raw) {
    if (!raw)
        return raw == null ? '' : raw;

    // 국제번호(+)·영문 메모(내선 등)는 한국식 보정 대상이 아니므로 원본 유지
    // (예: +1 415 555 1234 → 숫자 11자리로 오인해 한국식 분할되는 것을 차단)
    if (/[+a-zA-Z]/.test(raw))
        return raw;

    const d = raw.replace(/[^\d]/g, '');
    if (!d)
        return raw;

    // 서울 지역번호 02
    if (d.startsWith('02')) {
        if (d.length === 9)
            return `02-${d.slice(2, 5)}-${d.slice(5)}`;
        if (d.length === 10)
            return `02-${d.slice(2, 6)}-${d.slice(6)}`;

        return raw;
    }

    // 대표번호 8자리 (1588-XXXX 등, 0으로 시작 안 함)
    if (d.length === 8 && !d.startsWith('0'))
        return `${d.slice(0, 4)}-${d.slice(4)}`;

    // 3자리 국번 (지역 0XX / 휴대폰 01X)
    if (d.length === 10)
        return `${d.slice(0, 3)}-${d.slice(3, 6)}-${d.slice(6)}`;
    if (d.length === 11)
        return `${d.slice(0, 3)}-${d.slice(3, 7)}-${d.slice(7)}`;

    // 그 외 길이는 원본 유지 (국제번호·안심번호 050X·내선 등)
    return raw;
}
